(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rqst-cart-bar-footer')) {
    customElements.define('rqst-cart-bar-footer', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.closest('cart-bar');
        if (!this.bar) return;
        this.onChange = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateFooterSpace();
            this.updateColors();
          });
        };
        this.onResize = () => {
          this.footerSpace = null;
          this.onChange();
        };
        this.onSectionChange = () => this.connectFooter();
        window.addEventListener('scroll', this.onChange, { passive: true });
        window.addEventListener('resize', this.onResize);
        document.addEventListener('shopify:section:load', this.onSectionChange);
        document.addEventListener('shopify:section:unload', this.onSectionChange);
        document.addEventListener('DOMContentLoaded', this.onSectionChange);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onChange);
        }
        this.footerObserver = new MutationObserver(this.onChange);
        this.barObserver = new MutationObserver(this.onChange);
        this.barObserver.observe(this.bar, { attributes: true, attributeFilter: ['class'] });
        this.connectFooter();
      }

      connectFooter() {
        const footer = document.querySelector('.site-footer');
        if (this.footer && this.footer !== footer) this.clearFooterSpace();
        this.footer = footer;
        this.footerSpace = null;
        this.footerSection = this.footer?.closest('.shopify-section');
        const previousSection = this.footerSection?.previousElementSibling;
        this.coveringSection = previousSection?.matches('.shopify-section, .main-content')
          ? previousSection
          : document.querySelector('[data-main]');
        this.resizeObserver?.disconnect();
        this.resizeObserver?.observe(this.bar);
        if (this.footer) this.resizeObserver?.observe(this.footer);
        if (this.coveringSection) this.resizeObserver?.observe(this.coveringSection);
        this.footerObserver.disconnect();
        if (this.footerSection) {
          this.footerObserver.observe(this.footerSection, { attributes: true, attributeFilter: ['class'] });
        }
        this.onChange();
      }

      refreshFooter() {
        const effect = this.footer?.querySelector('footer-effect');
        if (effect?.isActive && typeof effect.refresh === 'function') effect.refresh();
        this.footer?.querySelector('parallax-element')?.refresh?.();
      }

      updateFooterSpace() {
        if (!this.footer?.isConnected) return;
        const visible = this.bar.classList.contains('is-visible') || this.bar.matches(':focus-within');
        const space = visible && this.bar.dataset.position !== 'top' ? Math.ceil(this.bar.offsetHeight) : 0;
        if (this.footerSpace === space) return;
        this.footerSpace = space;
        this.footer.style.setProperty('--rqst-cart-footer-space', `${space}px`);
        this.footer.classList.toggle('rqst-has-sticky-cart', space > 0);
        this.refreshFooter();
      }

      clearFooterSpace() {
        this.footer?.style.removeProperty('--rqst-cart-footer-space');
        this.footer?.classList.remove('rqst-has-sticky-cart');
        this.footerSpace = null;
        this.refreshFooter();
      }

      updateColors() {
        if (!this.footer?.isConnected) {
          this.bar.classList.remove('is-over-footer');
          return;
        }
        const footerRect = this.footer.getBoundingClientRect();
        let visibleFooterTop = footerRect.top;
        if (this.footerSection?.classList.contains('section-footer--parallax') && this.coveringSection?.isConnected) {
          visibleFooterTop = Math.max(visibleFooterTop, this.coveringSection.getBoundingClientRect().bottom);
        }
        const barTop = window.innerHeight - this.bar.offsetHeight;
        this.bar.classList.toggle('is-over-footer', visibleFooterTop <= barTop && footerRect.bottom > barTop);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onChange);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:section:load', this.onSectionChange);
        document.removeEventListener('shopify:section:unload', this.onSectionChange);
        document.removeEventListener('DOMContentLoaded', this.onSectionChange);
        this.resizeObserver?.disconnect();
        this.footerObserver?.disconnect();
        this.barObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.bar?.classList.remove('is-over-footer');
        this.clearFooterSpace();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rqst-banner-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rqst-banner-reveal')) {
    customElements.define('rqst-banner-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-reveal-complete') || this.dataset.animate !== 'true') return;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motionPreference.matches || !('IntersectionObserver' in window)) return;
        const frame = this.closest('.rqbi__frame');
        if (!frame || !this.childElementCount) return;
        this.finish = () => {
          this.setAttribute('data-revealed', '');
          this.setAttribute('data-reveal-complete', '');
          this.observer?.disconnect();
        };
        this.onAnimationEnd = event => {
          if (event.target === this && event.animationName === 'rqbiHeroRise') this.finish();
        };
        this.onPreferenceChange = event => { if (event.matches) this.finish(); };
        this.addEventListener('animationend', this.onAnimationEnd);
        this.addEventListener('focusin', this.finish);
        this.motionPreference.addEventListener('change', this.onPreferenceChange);
        this.setAttribute('data-reveal-ready', '');
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          const image = frame.querySelector('.rqbi__image');
          const imageReady = image?.decode ? image.decode().catch(() => {}) : Promise.resolve();
          Promise.all([document.fonts?.ready, imageReady]).then(() => {
            if (!this.isConnected || this.hasAttribute('data-reveal-complete')) return;
            const offset = Math.max(0, frame.getBoundingClientRect().bottom - this.getBoundingClientRect().top) + 1;
            this.style.setProperty('--rqbi-reveal-offset', `${offset}px`);
            this.setAttribute('data-revealed', '');
          });
        });
        this.observer.observe(frame);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.onAnimationEnd) this.removeEventListener('animationend', this.onAnimationEnd);
        if (this.finish) this.removeEventListener('focusin', this.finish);
        if (this.onPreferenceChange) this.motionPreference.removeEventListener('change', this.onPreferenceChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rqst-collection-header"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rqst-collection-sort')) {
    customElements.define('rqst-collection-sort', class extends HTMLElement {
      connectedCallback() {
        this.onChange = (event) => {
          if (!event.target.matches('select[name="sort_by"]')) return;
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.delete('page');
          window.location.assign(url.href);
        };
        this.addEventListener('change', this.onChange);
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rqst-editorial-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rqst-editorial-gallery')) {
    customElements.define('rqst-editorial-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
        if (!this.track || !this.slides.length) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onClick = event => {
          const button = event.target.closest('[data-gallery-dot]');
          const index = this.dots.indexOf(button);
          if (index >= 0) this.showSlide(index);
        };
        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateActive());
        };
        this.onKeyDown = event => {
          if (!this.mobile.matches || event.target !== this.track) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.showSlide(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        };
        this.onBlockSelect = event => {
          if (!this.mobile.matches || !this.contains(event.target)) return;
          const slide = event.target.closest('[data-gallery-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.showSlide(index, false);
        };
        this.onPointerDown = event => {
          if (!this.mobile.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
          event.preventDefault();
          this.drag = {id: event.pointerId, x: event.clientX, left: this.track.scrollLeft};
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
          this.track.focus({preventScroll: true});
        };
        this.onPointerMove = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          event.preventDefault();
          this.track.scrollLeft = this.drag.left + this.drag.x - event.clientX;
        };
        this.onPointerEnd = event => {
          if (event.pointerId === this.drag?.id) this.finishDrag();
        };
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('scroll', this.onScroll, {passive: true});
        this.track.addEventListener('keydown', this.onKeyDown);
        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('pointermove', this.onPointerMove);
        this.track.addEventListener('pointerup', this.onPointerEnd);
        this.track.addEventListener('pointercancel', this.onPointerEnd);
        this.track.addEventListener('lostpointercapture', this.onPointerEnd);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.updateActive());
        this.resizeObserver.observe(this.track);
        this.updateActive();
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.finishDrag(false);
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('keydown', this.onKeyDown);
        this.track?.removeEventListener('pointerdown', this.onPointerDown);
        this.track?.removeEventListener('pointermove', this.onPointerMove);
        this.track?.removeEventListener('pointerup', this.onPointerEnd);
        this.track?.removeEventListener('pointercancel', this.onPointerEnd);
        this.track?.removeEventListener('lostpointercapture', this.onPointerEnd);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      finishDrag(snap = true) {
        if (!this.drag) return;
        const pointerId = this.drag.id;
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(pointerId)) this.track.releasePointerCapture(pointerId);
        if (snap) this.showSlide(index);
      }
      showSlide(index, animate = true) {
        const next = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({left: this.slides[next].offsetLeft, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'auto'});
      }
      updateActive() {
        this.activeIndex = this.mobile.matches ? Math.round(this.track.scrollLeft / this.track.clientWidth) : 0;
        this.dots.forEach((dot, index) => {
          if (index === this.activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rqst-header-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rqst-header-localization')) {
    customElements.define('rqst-header-localization', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.toggle = this.querySelector('summary');
        this.onToggle = () => {
          this.toggle.setAttribute('aria-expanded', String(this.details.open));
          if (this.details.open) {
            document.querySelectorAll('rqst-header-localization').forEach((other) => {
              if (other !== this) other.close();
            });
          }
        };
        this.onOutside = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        this.onEscape = (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            event.stopPropagation();
            this.close(true);
          }
        };
        this.onFocusOut = () => requestAnimationFrame(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
        this.onResize = () => this.close();
        this.details.addEventListener('toggle', this.onToggle);
        this.addEventListener('keydown', this.onEscape);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('click', this.onOutside);
        window.addEventListener('resize', this.onResize);
      }
      close(restoreFocus = false) {
        if (!this.details.open) return;
        this.details.open = false;
        this.toggle.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.toggle.focus();
      }
      disconnectedCallback() {
        this.details.removeEventListener('toggle', this.onToggle);
        this.removeEventListener('keydown', this.onEscape);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('click', this.onOutside);
        window.removeEventListener('resize', this.onResize);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rqst-product-stars"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rqst-product-stars')) {
  customElements.define('rqst-product-stars', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      if (this.dataset.animate !== 'true' || this.hasAttribute('data-revealed')) return;
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motionQuery.matches) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motionQuery.addEventListener('change', () => {
        if (this.motionQuery.matches) this.finish();
      }, {signal});
      this.addEventListener('focusin', () => this.finish(), {signal});
      this.setAttribute('data-reveal-ready', '');
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.reveal();
      }, {threshold: 0.1});
      this.observer.observe(this);
    }
    reveal() {
      if (this.hasAttribute('data-revealed') || this.motionQuery.matches) return;
      this.setAttribute('data-revealed', '');
      this.observer.disconnect();
      const stars = [...this.querySelectorAll('.rqst-rating__star')];
      const frames = [{opacity: 0, transform: 'translateY(4px)'}, {opacity: 1, transform: 'translateY(0)'}];
      stars.forEach((star, index) => {
        this.revealAnimations.push(star.animate(frames, {
          duration: 350, delay: 150 + index * 150, easing: 'ease-in-out', fill: 'backwards'
        }));
      });
      this.querySelectorAll('.rqst-product-stars__number, .rqst-product-stars__label').forEach(text => {
        this.revealAnimations.push(text.animate(frames, {
          duration: 450, delay: 150 + stars.length * 150 + 200, easing: 'ease-in-out', fill: 'backwards'
        }));
      });
    }
    finish() {
      this.setAttribute('data-revealed', '');
      this.cleanup();
    }
    cleanup() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.revealAnimations?.forEach(animation => animation.cancel());
      this.revealAnimations = [];
      this.removeAttribute('data-reveal-ready');
    }
    disconnectedCallback() {this.cleanup();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
